import React from 'react';
import { BookPreviewCarousel } from './BookPreviewCarousel';
import { chapters } from '../data/landing';
export function ChaptersSection() {
  return <section id="contenido" className="scroll-mt-16 bg-ink" data-id="element-62" data-mp="3a461ixv904d0">
      <div className="mx-auto grid max-w-6xl gap-5 px-5 py-10 md:px-6 md:py-16 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:py-20" data-id="element-63" data-mp="3f27lrm4eu9q2">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-64" data-mp="3jzhhtkmb1jmv">
          <h2 className="font-display text-xl leading-tight text-cream md:text-3xl lg:text-4xl" data-id="element-65" data-mp="2mda33hwaeaws">
            ¿Qué descubrirás dentro del libro?
          </h2>
          <p className="mt-2 max-w-sm font-serif text-base md:mt-4 leading-relaxed text-muted md:text-xl" data-id="element-66" data-mp="2r98vdgkqkd2h">
            Seis recorridos que conectan la mente, la percepción y los símbolos
            que han acompañado a la humanidad.
          </p>
          <BookPreviewCarousel data-id="element-67" data-mp="23ky3h2x0pnqc" />
        </div>

        <ol className="border-t border-line" data-id="element-68" data-mp="23k6guhlef0c7">
          {chapters.map(c => <li key={c.number} className="grid grid-cols-[2.75rem_1fr] gap-2 border-b border-line py-3.5 md:grid-cols-[4rem_1fr] md:gap-4 md:py-6" data-id="element-69" data-mp="28j9dper86093">
              <span className="font-display text-lg text-gold md:text-2xl" data-id="element-70" data-mp="585064vzdzem">
                {c.number}
              </span>
              <div data-id="element-71" data-mp="ejzu66x0tc9">
                <h3 className="font-display text-[15px] text-cream md:text-lg" data-id="element-72" data-mp="3rnhbyby0yrqk">
                  {c.title}
                </h3>
                <p className="mt-1 text-sm md:mt-2 leading-relaxed text-muted md:text-base" data-id="element-73" data-mp="3nmno1ikl1cxo">
                  {c.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}